import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { ResolvedTheme } from "@/contexts/theme-provider";

interface ThemeStore {
  resolvedTheme: ResolvedTheme;
  setResolvedTheme: (theme: ResolvedTheme) => void;
  transparency: boolean;
  setTransparency: (value: boolean) => void;
}

function applyTransparencyClass(enabled: boolean) {
  if (typeof document !== "undefined") {
    document.documentElement.classList.toggle("transparency-off", !enabled);
  }
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      resolvedTheme: "light",
      setResolvedTheme: (theme) => set({ resolvedTheme: theme }),
      transparency: true,
      setTransparency: (value) => {
        applyTransparencyClass(value);
        set({ transparency: value });
      },
    }),
    {
      name: "decoda-theme-store",
      version: 1,
      partialize: (state) => ({
        transparency: state.transparency,
      }),
      migrate: (persistedState, version) => {
        const state = persistedState as Record<string, unknown>;
        if (version === 0) {
          // Migrate from transparencyOff (boolean) to transparency (inverted boolean)
          if ("transparencyOff" in state) {
            state.transparency = !state.transparencyOff;
            delete state.transparencyOff;
          } else {
            state.transparency = true;
          }
        }
        return state as { transparency: boolean };
      },
      onRehydrateStorage: () => {
        return (state) => {
          if (state) {
            applyTransparencyClass(state.transparency);
          }
        };
      },
    },
  ),
);
